export default {
  setUser (state, n) {
    state.user = n
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js